import store from '@/store';
import { deepCopy } from './utils';
export function setNavSate(routePath) {
  if (routePath.meta.activePath) {
    const active = routePath.meta.activePath.substring(1).split('/');
    if (active) {
      if (active.length === 2) {
        store.state.leftNavActive = `${active[1]}`;
      } else {
        store.state.leftNavOpen = [active[0], active[1]];
        store.state.leftNavActive = `${active[0]}_${active[1]}_${active[2]}`;
      }
    }
  }
}

export function filterLeftNav(list) {
  const lists = deepCopy(list);
  if (process.env.NODE_ENV == 'development') {
    return lists;
  }

  lists.forEach((item) => {
    // if (item.auth === '订单中心') {
    const childList = [];
    item.childList.forEach((childItem, key) => {
      let isFirstAuth = true; // 左边菜单 第一节点是否有权限
      if (childItem.auth && store.state.authMap[childItem.auth] != 1) {
        isFirstAuth = false;
      } else if (childItem.orgType && childItem.orgType !== store.state.adminIdentity[store.state.adminIdentityIndex].orgType) {
        isFirstAuth = false;
      } else {
        childList.push(childItem);
      }
      const childSecondList = [];
      if (isFirstAuth) {
        childItem.childList.forEach((childSecondItem, key_1) => {
          if (
            childSecondItem.auth &&
            store.state.authMap[childSecondItem.auth] != 1
          ) {
          } else if (childSecondItem.orgType && childSecondItem.orgType !== store.state.adminIdentity[store.state.adminIdentityIndex].orgType) {

          } else {
            if (childSecondItem.menuName != '平台轮播图') {
              childSecondList.push(childSecondItem);
            }
          }
          try {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (process.env.NODE_ENV === 'production') {
              if (
                childSecondItem.menuName == '平台轮播图' &&
                userInfo.orgId == '635808815551348737'
              ) {
                childSecondList.push(childSecondItem);
              }
            } else if (childSecondItem.menuName == '平台轮播图') {
              childSecondList.push(childSecondItem);
            }
          } catch (err) {}
        });
        childItem.childList = childSecondList;
      }
    });
    item.childList = childList;
    // }
  });

  return lists;

  // // 订单中心 - 分账 权限
  // if (+authMap['SETTING_DIVIDE_RULE'] !== 1) {
  //   lists.forEach((item) => {
  //     if (item.menuName === '订单中心') {
  //       const key = item.childList.findIndex((childItem) => {
  //         return childItem.menuName === '分账'
  //       })
  //       item.childList.splice(key, 1)
  //     }
  //   })
  // }
  // //  教师课酬梯度设置 权限
  // if (+authMap['SETTING_TEA_FEE_ALLOT'] !== 1) {
  //   lists.forEach((item) => {
  //     if (item.menuName === '基础信息中心') {
  //       item.childList.forEach((x) => {
  //         if (x.menuName === '运营管理') {
  //           const key = x.childList.findIndex((childItem) => {
  //             return childItem.menuName === '教师课酬梯度设置'
  //           })
  //           x.childList.splice(key, 1)
  //         }
  //       })
  //     }
  //   })
  // }

  return lists;
}
